@let executionData = execution();

<div class="flex flex-col gap-3 pl-6 pr-2 mt-6">
  <h2 class="text-xl font-bold mb-2">
    {{ 'pages.campaignDetails.ctaAnalytics.details.deliverables.title' | translate }}
  </h2>

  <app-manual-cta-result-matching-type
    [ctaResult]="ctaResult()"
    [matchingLabelKey]="getMatchingLabelKey(ctaResult())"
    [context]="matchingStatusContext()"
    [manualMatchingStatus]="getManualStatusForCta(ctaResult().ctaId)"
    [isSelected]="true"
    [actionsVisible]="matchingActionsVisible()"
    [subheaderVisible]="matchingSubheaderVisible()"
    textSize="sm"
  />

  @if (showSeeAlsoSection()) {
    <div class="flex gap-4 items-start">
      <span class="text-xs text-shikenso-purple-base-60 pt-0.5">
        {{ 'pages.campaignDetails.ctaAnalytics.details.deliverables.seeAlso' | translate }}
      </span>

      <div class="flex flex-col gap-3 flex-1 min-w-0">
        @for (otherCta of otherCtas(); track otherCta.ctaId) {
          <app-manual-cta-result-matching-type
            [ctaResult]="otherCta"
            [matchingLabelKey]="getMatchingLabelKey(otherCta)"
            [context]="matchingStatusContext()"
            [manualMatchingStatus]="getManualStatusForCta(otherCta.ctaId)"
            [isSelected]="false"
            [actionsVisible]="false"
            [subheaderVisible]="matchingSubheaderVisible()"
            textSize="xs"
            (showRequested)="onShowClick($event)"
          />
        }
      </div>
    </div>
  }

  @if (showTimingSection()) {
    <div class="flex flex-col gap-2">
      <h2 class="text-base mt-2">
        {{ 'pages.campaignDetails.ctaAnalytics.table.sponsoredContent' | translate }}
      </h2>

      <div class="flex gap-[104px] w-full rounded-xl py-3 px-4 border border-shikenso-purple-base-12">
        @if (executionData.status === EMatchingType.matched) {
          <div class="flex flex-col gap-2">
            <span class="text-[10px] text-shikenso-purple-base-60">
              {{ 'pages.campaignDetails.ctaAnalytics.table.planned' | translate }}
            </span>

            <div class="flex flex-col flex-wrap gap-1 items-start text-xs pl-1">
              <div class="flex gap-1 items-center">
                @if (executionData.details.plannedStartDate) {
                  <app-icon src="/icons/calendar-event.svg" alt="Planned Start Date" class="w-4 h-4 shrink-0" />
                  <span>{{ executionData.details.plannedStartDate }}</span>
                  <span>|</span>
                  <span class="mr-3">{{ executionData.details.plannedStartTime ?? '-' }}</span>
                } @else {
                  <app-icon src="/icons/calendar-event.svg" alt="Planned Start Date" class="w-4 h-4 shrink-0" />
                  <span class="text-shikenso-purple-base-24 mr-3">{{ 'shared.notSet' | translate }}</span>
                }
              </div>

              <div class="flex gap-1 items-center">
                @if (executionData.details.plannedDuration !== undefined) {
                  @if (executionData.details.plannedDuration) {
                    <app-icon src="/icons/clock.svg" alt="Planned Duration" class="w-4 h-4 shrink-0" />
                    <span>{{ executionData.details.plannedDuration | duration }}</span>
                  } @else {
                    <app-icon src="/icons/clock.svg" alt="Planned Duration" class="w-4 h-4 shrink-0" />
                    <span class="text-shikenso-purple-base-24">{{ 'shared.notSet' | translate }}</span>
                  }
                }
              </div>
            </div>
          </div>
        }

        @if (showSponsoredTiming()) {
          <div class="flex flex-col gap-2">
            <span class="text-[10px] text-shikenso-purple-base-60">
              {{ 'pages.campaignDetails.ctaAnalytics.table.executed' | translate }}
            </span>

            <div class="flex flex-col flex-wrap gap-1 items-start text-xs pl-1">
              <div class="flex gap-1 items-center">
                @if (executionData.details.sponsoredContentStartDate) {
                  <app-icon
                    src="/icons/calendar-event.svg"
                    alt="Sponsored Content Start Date"
                    class="w-4 h-4 shrink-0"
                  />
                  <span>{{ executionData.details.sponsoredContentStartDate }}</span>
                  <span>|</span>
                  <span class="mr-3">{{ executionData.details.sponsoredContentStartTime ?? '-' }}</span>
                } @else {
                  <app-icon
                    src="/icons/calendar-event.svg"
                    alt="Sponsored Content Start Date"
                    class="w-4 h-4 shrink-0"
                  />
                  <span class="text-shikenso-purple-base-24 mr-3">{{ 'shared.notAvailable' | translate }}</span>
                }
              </div>

              <div class="flex gap-1 items-center">
                @if (executionData.details.sponsoredContentDuration !== undefined) {
                  @if (executionData.details.sponsoredContentDuration) {
                    <app-icon src="/icons/clock.svg" alt="Sponsored Content Duration" class="w-4 h-4 shrink-0" />
                    <span>{{ executionData.details.sponsoredContentDuration | duration }}</span>
                  } @else {
                    <app-icon src="/icons/clock.svg" alt="Sponsored Content Duration" class="w-4 h-4 shrink-0" />
                    <span class="text-shikenso-purple-base-24">{{ 'shared.notAvailable' | translate }}</span>
                  }
                }
              </div>
            </div>
          </div>
        }

        @if (showSponsoredKpis()) {
          <div class="flex flex-col gap-2">
            <span class="text-[10px] text-shikenso-purple-base-60">
              {{ 'pages.campaignDetails.ctaAnalytics.table.performance' | translate }}
            </span>

            <div class="flex flex-wrap gap-12 items-start text-xs pl-1">
              @for (kpi of sponsoredKpis(); track kpi.label) {
                <div class="flex flex-col items-center gap-2">
                  <div class="flex gap-1 items-center">
                    <app-icon [src]="kpi.icon" [alt]="kpi.label" class="w-4 h-4 shrink-0" />
                    <span [matTooltip]="kpi.value | numberLocale">
                      {{ kpi.value! | numberSuffix }}
                    </span>
                  </div>

                  <span class="text-[10px]">{{ kpi.label }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
